import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./NewNavigation.css";

class NewNavigationItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.isMobile)
      return (
        <>
          <a className={styles.mobileSectionHeader} href={this.props.url}>
            {this.props.name}
          </a>
        </>
      );
  }
}

NewNavigationItem.proptypes = {
  isMobile: PropTypes.bool,
  mobileToggle: PropTypes.func,
  name: PropTypes.string,
  url: PropTypes.string,
};

export default NewNavigationItem;
